/**
 * 서식 조건식 평가.
 *
 * 서버(app/services/template_service.py)와 **동일한 규칙**이어야 한다.
 * 클라이언트가 보여준 페이지와 서버가 요구하는 서명 슬롯이 어긋나면
 * 시민은 서명을 다 했는데 제출이 거부되는 상황이 된다.
 *
 * eval() 을 쓰지 않는다: 서식 정의는 DB 에서 편집되므로 코드 실행 경로가 되면 안 된다.
 */

const CONDITION = /^\s*([a-zA-Z_][\w.]*)\s+(in|not in|==|!=|>=|<=|>|<)\s+(.+?)\s*$/;

export function resolvePath(data: unknown, path: string): unknown {
  let current: unknown = data;
  for (const part of path.split('.')) {
    if (current === null || current === undefined) return null;
    if (typeof current !== 'object') return null;
    current = (current as Record<string, unknown>)[part];
  }
  return current ?? null;
}

function parseLiteral(raw: string): unknown {
  const text = raw.trim();
  if (text.startsWith('[') && text.endsWith(']')) {
    return text
      .slice(1, -1)
      .split(',')
      .filter((part) => part.trim() !== '')
      .map(parseLiteral);
  }
  if ((text.startsWith("'") && text.endsWith("'")) || (text.startsWith('"') && text.endsWith('"'))) {
    return text.slice(1, -1);
  }
  if (text === 'true') return true;
  if (text === 'false') return false;
  if (text === 'null') return null;
  const num = Number(text);
  return Number.isNaN(num) ? text : num;
}

export function evaluateCondition(expr: string | undefined | null, data: unknown): boolean {
  if (!expr) return true;

  const match = CONDITION.exec(expr);
  if (!match) throw new Error(`지원하지 않는 조건식입니다: ${expr}`);

  const [, path, op, rawValue] = match;
  const left = resolvePath(data, path!);
  const right = parseLiteral(rawValue!);
  const list = Array.isArray(right) ? right : [right];

  switch (op) {
    case 'in':
      return list.includes(left);
    case 'not in':
      return !list.includes(left);
    case '==':
      return left === right;
    case '!=':
      return left !== right;
  }

  if (left === null || right === null) return false;
  const a = left as number;
  const b = right as number;
  switch (op) {
    case '>':
      return a > b;
    case '<':
      return a < b;
    case '>=':
      return a >= b;
    case '<=':
      return a <= b;
    default:
      return false;
  }
}
